import React from 'react';
import moment from 'moment';

// style
import './style.css';

export default (props) => (
    <footer className={props.className}>
        <p className="kerenor-studio">© Kerenor Dental Studio {moment().year()}</p>
    </footer>
);


// WEBPACK FOOTER //
// ./src/shared/components/footer/index.js